import { render } from "./proof.vue?vue&type=template&id=1cd13d1e&scoped=true"
import script from "./proof.vue?vue&type=script&lang=js"
export * from "./proof.vue?vue&type=script&lang=js"

import "./proof.vue?vue&type=style&index=0&id=1cd13d1e&scoped=true&lang=css"

import exportComponent from "E:\\工作\\校闪招\\code\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cd13d1e"]])

export default __exports__